import apiClient from '../api/apiClient';
import { API_ENDPOINTS } from '../api/endpoints';

export const reviewsService = {
  getReviews: async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.REVIEWS);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch reviews.',
      };
    }
  },
};

export default reviewsService;
